import React from 'react';

import { Card, List } from 'antd';
import { RowLine, SpanBlock } from './styles';
import mask from '../../../../../utils/mask';

const CardMobile: React.FC<any> = ({
  props,
  loading,
  inscricaoAtiva,
  cddAtivo,
  filter,
  pagination,
}) => {
  const paginationProps = {
    showSizeChanger: true,
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: pagination.total,
  };

  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      pagination={paginationProps}
      loading={loading}
      dataSource={props}
      renderItem={(item: any) => (
        <List.Item>
          <Card title={props.nome}>
            <RowLine>
              <p>
                <strong>Nome</strong> <SpanBlock>{item.nome}</SpanBlock>
              </p>
              <p>
                <strong>CPF</strong> <SpanBlock>{mask('cpfCnpj', item.cnpjCpf)}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Cat. Habilitação</strong>
                <SpanBlock> {item.nroCnh} </SpanBlock>
              </p>
              <p>
                <strong>Validade</strong>
                <SpanBlock>{item.vencimentoCnh}</SpanBlock>
              </p>
            </RowLine>
          </Card>
        </List.Item>
      )}
    />
  );
};
export default CardMobile;
